export default "__VITE_ASSET__bf598731__"